import { alphartisApiAxios } from "@/config/axios";
import { useMutation } from "@tanstack/react-query";

const WEB_PUSH_UNSUBSCRIBE_PATH = "/v1/notification/web-push/unsubscribe" as const;

export const useUnsubscribeWebPushMutation = () => {
  return useMutation<void, Error, string>({
    mutationFn: async (endpoint: string) => {
      await alphartisApiAxios.post(WEB_PUSH_UNSUBSCRIBE_PATH, { endpoint }, { skipErrorHandling: true });
    },
  });
};
